import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'apps/cinema1/src/environments/environment';
import { possibleCinemaParams, storageKey } from 'libs/core/src/app.const';
import { ChoiceSliderItem } from 'libs/core/src/lib/component/choice-slider/model/choice-slider-item';
import { CardDataProvider } from 'libs/core/src/lib/data-provider/card.data-provider';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { CardTypeViewModel } from 'libs/core/src/lib/model/view-model/card/card-type.view.model';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { getValidGuidOrNull, getValueFromQueryParameters, isNullOrEmpty } from 'libs/core/src/lib/function/custom-function';
import { cloneDeep } from 'lodash-es';
import { CinemaViewModel } from 'libs/core/src/lib/model/view-model/cinema/cinema.view.model';
import { CinemaDataProvider } from 'libs/core/src/lib/data-provider/cinema.data-provider';

@Component({
  standalone: false,
  selector: 'app-gift-cards-page',
  templateUrl: './gift-cards-page.component.html',
  styleUrls: ['./gift-cards-page.component.scss']
})
export class CustomGiftCardsPageComponent implements OnInit {
  onlineGraphicItems: Map<string, Array<ChoiceSliderItem>> = new Map<string, Array<ChoiceSliderItem>>();
  physicalGraphicItems: Map<string, Array<ChoiceSliderItem>> = new Map<string, Array<ChoiceSliderItem>>();

  cards: CardTypeViewModel[] = [];
  onlineCards: CardTypeViewModel[] = [];
  physicalCards: CardTypeViewModel[] = [];

  noCinemaContext = false;

  cinemaList: CinemaViewModel[] = null;

  constructor(
    protected loaderService: LoaderService,
    protected orderStateService: OrderStateService,
    protected cardDataProvider: CardDataProvider,
    protected route: ActivatedRoute,
    protected cinemaDataProvider: CinemaDataProvider
  ) {}

  ngOnInit() {
    let cinemaId =
      this.tryExtractUrlParametersAndGetCinemaId() ||
      this.orderStateService.getCinemaId() ||
      this.orderStateService.getItem(storageKey.chosenLocation) ||
      environment.constants?.defaultCinemaId;

    if (cinemaId) {
      this.initialPage(cinemaId);
    } else {
      this.displayCinemaSelector();
    }
  }

  checkCanDisplayInTabs() {
    return [this.onlineCards, this.physicalCards].filter((f) => !isNullOrEmpty(f)).length > 1;
  }

  onCinemaChange(cinema: CinemaViewModel) {
    this.showLoader();
    this.noCinemaContext = false;
    this.initialPage(cinema.id);
  }

  private initialPage(cinemaId: string) {
    this.cardDataProvider.types(cinemaId).subscribe((cards) => {
      this.onlineGraphicItems.clear();
      this.physicalGraphicItems.clear();

      this.cards = cards
        .filter((x) => x.types.find((type) => type.number === 32) && (x.batchList = x.batchList.filter((y) => y.canBeIssued)))
        .filter((x) => x.batchList.length > 0);

      for (const card of this.cards) {
        for (const batch of card.batchList) {
          const choiceSliderItem = new ChoiceSliderItem();
          choiceSliderItem.graphic = batch.graphic;
          choiceSliderItem.key = batch.id;
          choiceSliderItem.unlimited = batch.unlimited;

          batch.unlimited
            ? this.onlineGraphicItems.has(card.id)
              ? this.onlineGraphicItems.get(card.id).push(choiceSliderItem)
              : this.onlineGraphicItems.set(card.id, [choiceSliderItem])
            : this.physicalGraphicItems.has(card.id)
              ? this.physicalGraphicItems.get(card.id).push(choiceSliderItem)
              : this.physicalGraphicItems.set(card.id, [choiceSliderItem]);
        }
      }

      this.physicalCards = cloneDeep(this.cards)
        .map((x) => {
          x.batchList = x.batchList.filter((y) => y.unlimited === false && y.canBeIssued);
          return x;
        })
        .filter((z) => z.batchList.length > 0);

      this.onlineCards = cloneDeep(this.cards)
        .map((x) => {
          x.batchList = x.batchList.filter((y) => y.unlimited === true && y.canBeIssued);
          return x;
        })
        .filter((z) => z.batchList.length > 0);

      this.hideLoader();
    });
  }

  private tryExtractUrlParametersAndGetCinemaId() {
    const queryParams: { [key: string]: string } = {};
    Object.entries(this.route.snapshot.queryParams).forEach(([key, value]) => {
      queryParams[key.toLowerCase()] = (value as string).toLowerCase();
    });

    if (Object.keys(queryParams).length > 0) {
      const cinemaId = getValidGuidOrNull(getValueFromQueryParameters(possibleCinemaParams, queryParams));
      return cinemaId ? cinemaId.toLowerCase() : null;
    }

    return null;
  }

  private displayCinemaSelector() {
    this.noCinemaContext = true;
    this.cinemaDataProvider.getCinemas().subscribe((cinemaList: CinemaViewModel[]) => {
      this.cinemaList = cinemaList;
      this.hideLoader();
    });
  }

  private showLoader() {
    this.loaderService.showLoader(LoaderEnum.MAIN);
  }

  private hideLoader() {
    this.loaderService.hideLoader(LoaderEnum.MAIN);
  }
}
